// Module
var code = "<component :is=\"rootType\"> <slot :actor=\"actor\" :loading=\"loading\">{{ name }}</slot> </component> ";
// Exports
export default code;